'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
const NewThemeWizard = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignComponents/modals/NewThemeWizard'));
export default function withNewThemeWizard(WrappedComponent) {
  class HighOrderWithNewThemeWizard extends Component {
    constructor(props) {
      super(props);

      this.handleNewThemeCallback = () => {
        this.setState({
          open: false
        });
      };

      this.handleNewThemeClick = () => {
        this.setState({
          open: true
        });
      };

      this.renderNewThemeWizard = () => {
        if (!this.state.open) {
          return null;
        }

        return /*#__PURE__*/_jsx(NewThemeWizard, {
          callback: this.handleNewThemeCallback,
          folderId: this.props.folderId
        });
      };

      this.state = {
        open: false
      };
    }

    render() {
      const renderedNewThemeWizard = this.renderNewThemeWizard();
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        NewThemeWizard: renderedNewThemeWizard,
        onNewThemeClick: this.handleNewThemeClick
      }));
    }

  }

  HighOrderWithNewThemeWizard.propTypes = {
    folderId: FolderPropTypes.folderId
  };
  HighOrderWithNewThemeWizard.defaultProps = {
    folderId: null
  };
  return HighOrderWithNewThemeWizard;
}